import CONSTANTS from '../lib/constants';

const infoBox = ({ selector }) => {
  const infoBoxWrapper = document.querySelector(selector);
  const sgVersion = CONSTANTS.STYLEGUIDE_VERSION;

  if (!infoBoxWrapper) return;

  const show = ({ message, type = 'WARNING', withIcon = true }) => {
    let boxIcon = 'info-circle';
    let boxType = 'info';

    switch (type) {
      case 'OVERWEIGHT':
        boxIcon = 'parcel';
        break;
      case 'ERROR':
        boxIcon = 'smilie-sad';
        boxType = 'warning';
        break;
      case 'NOTICE':
        boxIcon = 'smilie-happy';
        boxType = 'success';
        break;
    }

    infoBoxWrapper.innerHTML = `
        <div class="info__box ${type} ${sgVersion}-notification ${sgVersion}-notification--${boxType}" role="alert" data-grid-${sgVersion}="12">
          <div class="info__body ${sgVersion}-notification__body">
                ${
                  withIcon &&
                  `<i class="${sgVersion}-notification__icon--${boxType}">
                    <svg class="checkout__icon" data-zta="infoBoxIcon"><use xlink:href="#${boxIcon}"></use></svg>
                </i>`
                }
              <div class="${sgVersion}-notification__text ${sgVersion}-p1 info__text" data-zta="infoBoxText">${message}</div>
          </div>
      </div>`;
  };

  return {
    show,
  };
};

export default infoBox;
